import React, { useState } from 'react';
import { Archive, Loader2, Mic } from 'lucide-react';
import { toast } from 'sonner';
import { useVoiceovers } from './VoiceoverContext';
import { buildDoc } from './ScriptDownloadButton';

const save = (blob, name) => {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 4000);
};

export const VoiceoverTools = () => {
  const { clips, items, generate, audioBlob } = useVoiceovers();
  const [progress, setProgress] = useState(null);
  const [zipping, setZipping] = useState(false);
  const done = clips.filter((c) => items[c.ref]).length;

  const createAll = async () => {
    let failed = 0;
    for (let i = 0; i < clips.length; i += 1) {
      setProgress(`${i + 1}/${clips.length}`);
      try { await generate(clips[i].ref); } catch (e) { failed += 1; }
    }
    setProgress(null);
    if (failed) toast.error(`${failed} voice-overs failed — click again to retry`);
    else toast.success('All voice-overs are ready');
  };

  const downloadZip = async () => {
    setZipping(true);
    try {
      const JSZip = (await import('jszip')).default;
      const zip = new JSZip();
      const root = zip.folder('AudiNexa-Showcase');
      for (const c of clips) {
        for (let k = 0; k < c.shots.length; k += 1) {
          const r = await fetch(`/${c.shots[k]}`);
          if (r.ok) root.file(`${c.name}${c.shots.length > 1 ? `-${'ab'[k]}` : ''}.png`, await r.blob());
        }
        if (items[c.ref]) root.file(`${c.name}.mp3`, await audioBlob(c.ref));
      }
      root.file('AudiNexa-Voiceover-Script.docx', await buildDoc());
      save(await zip.generateAsync({ type: 'blob' }), 'AudiNexa-Showcase-Media.zip');
      toast.success(done < clips.length ? `ZIP ready — ${clips.length - done} clips have no voice-over yet` : 'ZIP ready');
    } catch (e) {
      toast.error('Could not build the ZIP');
    } finally {
      setZipping(false);
    }
  };

  return (
    <>
      <button type="button" className="sc-btn sc-btn-ghost" onClick={createAll} disabled={!!progress} data-testid="showcase-voiceover-all-btn">
        {progress ? <Loader2 size={16} className="animate-spin" /> : <Mic size={16} />}
        {progress ? `Creating ${progress}` : `Voice-overs ${done}/${clips.length}`}
      </button>
      <button type="button" className="sc-btn sc-btn-ghost" onClick={downloadZip} disabled={zipping || !!progress} data-testid="showcase-zip-btn">
        {zipping ? <Loader2 size={16} className="animate-spin" /> : <Archive size={16} />}
        {zipping ? 'Building ZIP…' : 'Download media ZIP'}
      </button>
    </>
  );
};
